import { useState } from 'react';
import { TextField, InputAdornment, IconButton, type TextFieldProps } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export interface PasswordFieldProps extends Omit<TextFieldProps, 'type'> {
  // Modo controlado: permite compartir un mismo toggle entre dos campos (UC-3, "Confirmar
  // contraseña" comparte `showPassword` con "Nueva contraseña"). Si se omiten, el campo gestiona
  // su propio estado internamente (modo por defecto, UC-1/UC-4 "Actual"/"Nueva" independientes).
  show?: boolean;
  onToggleShow?: () => void;
}

/** Campo de contraseña con toggle de visibilidad, reusado por las páginas de auth. */
export default function PasswordField({
  show: controlledShow,
  onToggleShow,
  ...props
}: PasswordFieldProps) {
  const [internalShow, setInternalShow] = useState(false);
  const show = controlledShow ?? internalShow;
  const toggle = onToggleShow ?? (() => setInternalShow((s) => !s));
  return (
    <TextField
      {...props}
      type={show ? 'text' : 'password'}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={toggle} edge="end" size="small">
                {show ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
